<template>
    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li :class="[ 'page-item', pagination.hasPrev ? '' : 'disabled' ]">
          <a class="page-link"
             href="#"
             @click.prevent="selecionarPagina(1)">
            <span>&laquo;&laquo;</span>
          </a>
        </li>
        <li :class="[ 'page-item', pagination.hasPrev ? '' : 'disabled' ]">
          <a class="page-link"
             href="#"
             @click.prevent="selecionarPagina(pagination.pageNumber - 1)">
            <span>&laquo;</span>
          </a>
        </li>

        <li :class="[ 'page-item', pagination.pageNumber === index ? 'disabled' : '' ]" v-for="index in calcularQuantidadeDePaginas()" :key="index">
          <a class="page-link" href="#" @click.prevent="selecionarPagina(index)">{{index}}</a>
        </li>

        <li :class="[ 'page-item', pagination.hasNext ? '' : 'disabled' ]">
          <a class="page-link"
             href="#"
             @click.prevent="selecionarPagina(pagination.pageNumber + 1)">
            <span>&raquo;</span>
          </a>
        </li>
        <li :class="[ 'page-item', pagination.hasNext ? '' : 'disabled' ]">
          <a class="page-link"
             href="#"
             @click.prevent="selecionarPagina(-1)">
            <span>&raquo;&raquo;</span>
          </a>
        </li>
      </ul>
    </nav>
</template>

<script>
import eventBus from '@/uteis/eventBus'

export default {
  props: {
    pagination: { required: true, type: Object },
    eventBusDataPaginationName: { required: true, type: String }
  },

  data () {
    return {
      paginaSelecionada: 1
    }
  },

  methods: {
    calcularQuantidadeDePaginas () {
      const paginas = []
      const primeiraPagRange = this.pagination.pageNumber - (this.pagination.prevPages > 3 ? 3 : this.pagination.prevPages)
      const ultimaPagRange = primeiraPagRange + 6 < this.pagination.pageNumber + this.pagination.nextPages ? primeiraPagRange + 6 : this.pagination.pageNumber + this.pagination.nextPages

      for (let i = primeiraPagRange; i <= ultimaPagRange; i++) {
        paginas.push(i)
      }

      return paginas
    },

    totalPagePopulado () {
      if (!this.pagination.totalReg && !this.pagination.pageCount) {
        this.pagination.totalPage = 0
        return
      }

      var totalPage = Math.ceil(this.pagination.totalReg / this.pagination.pageCount)
      this.pagination.totalPage = totalPage.toFixed(0)
    },

    definirPrimeiraPagRange () {
      if (this.pagination.totalPage <= 10) {
        return 1
      } else if ((this.paginaSelecionada + 4) >= this.pagination.totalPage) {
        return this.pagination.totalPage - 9
      } else if ((this.paginaSelecionada - 6) < 1) {
        return 1
      } else {
        return this.paginaSelecionada - 5
      }
    },

    definirUltimaPagRange () {
      if (this.pagination.totalPage <= 10) {
        return this.pagination.totalPage
      } else if ((this.paginaSelecionada + 4) > 10) {
        if ((this.paginaSelecionada + 4) > this.pagination.totalPage) {
          return this.pagination.totalPage
        } else {
          return this.paginaSelecionada + 4
        }
      } else {
        return 10
      }
    },

    selecionarPagina (pagina) {
      this.paginaSelecionada = pagina
      eventBus.$emit(this.eventBusDataPaginationName, pagina)
      this.calcularQuantidadeDePaginas()
    }
  },

  destroyed () {
    eventBus.$off(this.eventBusDataPaginationName)
  }
}
</script>

<style scoped>

</style>
